import React from 'react';

/**
 * ADGS Logo Component
 * Modern, sleek logo following Apple Human Interface Guidelines
 * Clean typography with subtle animations and professional appearance
 */
interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'white' | 'dark';
  className?: string;
  animated?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  variant = 'default', 
  className = '',
  animated = true 
}) => {
  // Size mappings
  const sizeClasses = {
    sm: 'text-lg font-bold',
    md: 'text-2xl font-bold',
    lg: 'text-3xl font-bold',
    xl: 'text-4xl font-bold'
  };

  // Color variants
  const colorClasses = {
    default: 'text-foreground',
    white: 'text-white',
    dark: 'text-gray-900'
  };

  // Animation classes
  const animationClasses = animated ? 'transition-all duration-300 hover:scale-105' : '';

  return (
    <div className={`flex items-center space-x-2 ${animationClasses} ${className}`}>
      {/* ADGS Logo in same style as old S&G logo */}
      <div className="w-12 h-12 bg-gradient-primary rounded-lg flex items-center justify-center shadow-lg">
        <span className="text-white font-bold text-base">ADGS</span>
      </div>
    </div>
  );
};

export default Logo;
